import { StoryblokTabbedContentEntry } from './StoryblokTabbedContentEntry'

import { createTabbedContentEntry } from './__mocks__/tabbedContentEntry'

export { createTabbedContentEntry }

// Re-export for backward compatibility
export const dummyTabbedContentEntryBlok = createTabbedContentEntry()

export default StoryblokTabbedContentEntry
